const CoursesProducts = [
  {
    category: "CampusX Courses",
    courses: [
      {
        name: "Data Science Mentorship Program 1.0",
        link: "https://t.me/c/2270190947/3583/6132",
      },
      {
        name: "Data Science Mentorship Program 2.0",
        link: "https://t.me/c/2270190947/3583/6129",
      },
      {
        name: "Web Scraping",
        link: "https://t.me/c/2270190947/3583/6129",
      },
    ],
  },

  {
    category: "Apna College Courses",
    courses: [
      {
        name: "Alpha course (C++ DSA)",
        link: "https://t.me/c/2270190947/3581/5910",
      },
      {
        name: "DELTA BATCH - WEB DEVELOPMENT",
        link: "https://t.me/c/2270190947/3581/21784",
      },
      {
        name: "ALPHA CODING BATCH 3.0",
        link: "https://t.me/c/2270190947/3581/36833",
      },
      {
        name: "Sigma 5.0",
        link: "https://t.me/c/2270190947/3581/24795",
      },
      {
        name: "Sigma 6.0",
        link: "https://t.me/c/2270190947/3581/21880",
      },
      {
        name: "Sigma 7.0",
        link: "https://t.me/c/2270190947/3581/21880",
      },
    ],
  },
  {
    category: "PW Skills Courses",
    courses: [
      {
        name: "Full Stack Web Development",
        link: "https://t.me/c/2270190947/9419/9420",
      },
      {
        name: "Pw Skills - Data Science With Generative Ai Course ⚡️",
        link: "https://t.me/c/2270190947/9419/25077",
      },
    ],
  },
  {
    category: "SAT Collection",
    courses: [
      {
        name: "Courses",
        link: "https://t.me/c/2270190947/36887/36888",
      },
      {
        name: "Books and Notes",
        link: "https://t.me/c/2270190947/36887/36888",
      },
    ],
  },
  {
    category: "PrepBytes Courses",
    courses: [
      {
        name: "DSA in C++ Course",
        link: "https://t.me/c/2270190947/24109/24111",
      },
      {
        name: "Interview Preparation In JAVA",
        link: "https://t.me/c/2270190947/24109/24123",
      },
    ],
  },
  {
    category: "Coding Ninjas Courses",
    courses: [
      {
        name: "Web Development Course",
        link: "https://t.me/c/2270190947/22980/22982",
      },
      {
        name: "Advanced Front-End Web Development with React",
        link: "https://t.me/c/2270190947/22980/23030",
      },
      {
        name: "Java Foundation with Data Structures & Algorithms [English & Hindi]",
        link: "https://t.me/c/2270190947/22980/23049",
      },
      {
        name: "Python Foundation with Data Structures & Algorithms",
        link: "https://t.me/c/2270190947/22980/23090",
      },
      {
        name: "Machine Learning and Data Science",
        link: "https://t.me/c/2270190947/22980/23123",
      },
    ],
  },
  {
    category: "Coding Blocks Courses",
    courses: [
      {
        name: "Android App Development Master Course",
        link: "https://t.me/c/2270190947/21989/21991",
      },
      {
        name: "Web Development with Python-Django",
        link: "https://t.me/c/2270190947/21989/22036",
      },
      {
        name: "Master Interview Questions for FAANG & Product Companies",
        link: "https://t.me/c/2270190947/21989/22069",
      },
      {
        name: "Competitive programming",
        link: "https://t.me/c/2270190947/21989/22086",
      },
    ],
  },
  {
    category: "Zero to Mastery Courses",
    courses: [
      {
        name: "Complete Angular Developer in 2023 - Zero To Mastery",
        link: "https://t.me/c/2270190947/23198/23200",
      },
      {
        name: "Complete SQL + Databases Bootcamp: Zero to Mastery",
        link: "https://t.me/c/2270190947/23198/23220",
      },
      {
        name: "DevOps Bootcamp: Learn Linux & Become a Linux Sysadmin",
        link: "https://t.me/c/2270190947/23198/23240",
      },
      {
        name: "Become a UI/UX Designer",
        link: "https://t.me/c/2270190947/23198/23244",
      },
      {
        name: "Complete Node.js Developer in 2023",
        link: "https://t.me/c/2270190947/23198/23249",
      },
      {
        name: "The Complete Web Developer in 2023",
        link: "https://t.me/c/2270190947/23198/23256",
      },
    ],
  },
  {
    category: "Academind Courses",
    courses: [
      {
        name: "MongoDB - The Complete Developer's Guide",
        link: "https://t.me/c/2270190947/23264/23266",
      },
      {
        name: "Git & GitHub - The Practical Guide - Academind",
        link: "https://t.me/c/2270190947/23264/23286",
      },
      {
        name: "Angular - The Complete Guide",
        link: "https://t.me/c/2270190947/23264/23407",
      },
      {
        name: "PYTHON - THE PRACTICAL GUIDE",
        link: "https://t.me/c/2270190947/23264/23411",
      },
      {
        name: "React - The Complete Guide",
        link: "https://t.me/c/2270190947/23264/23414",
      },
      {
        name: "JavaScript - The Complete Guide 2022 (Beginner + Advanced)",
        link: "https://t.me/c/2270190947/23264/23421",
      },
      {
        name: "Learn Flutter & Dart to Build iOS & Android Apps",
        link: "https://t.me/c/2270190947/23264/23427",
      },
    ],
  },
  {
    category: "Naresh IT Courses",
    courses: [
      {
        name: "UI Full Stack Web Development",
        link: "https://t.me/c/2270190947/22269/22289",
      },
      {
        name: "Core Java by Uday pawar- Jsspiders",
        link: "https://t.me/c/2270190947/22269/22387",
      },
      {
        name: "REACT JS BY RAVINDER KANCHI SIR ",
        link: "https://t.me/c/2270190947/22269/22417",
      },
      {
        name: "Angular by Sudhakar sharma sir",
        link: "https://t.me/c/2270190947/22269/22467",
      },
    
    ],
  },
  {
    category: "Batch Courses",
    courses: [
      {
        name: "🎯Batch - Cyber Securities-Ethical Hacking Course Batch 3",
        link: "https://t.me/c/2270190947/20751/34992",
      },
      {
        name: "🎯Batch - Python Programming by Vikas Singh",
        link: "https://t.me/c/2270190947/20751/34944",
      },
      {
        name: "🎯Batch - PYTHON Web Development ",
        link: "https://t.me/c/2270190947/20751/34894",
      },
      {
        name: "‼️ADVANCE DIPLOMA IN COMPUTER APPLICATION",
        link: "https://t.me/c/2270190947/20751/33861",
      },
      {
        name: "🌟 Excel Crash Course Aʟʟ Lᴇᴄᴛᴜʀᴇs...! 🌟",
        link: "https://t.me/c/2270190947/20751/33690",
      },
      {
        name: "🎯Target Batch - YouTube Step By Step Guide_enc",
        link: "https://t.me/c/2270190947/20751/33526",
      },
      {
        name: "🎯Target Batch - Data Structure & Algorithms Using C & C++",
        link: "https://t.me/c/2270190947/20751/33495",
      },
      {
        name: "🎯Target Batch - HTML Web Development_enc",
        link: "https://t.me/c/2270190947/20751/33462",
      },
      {
        name: "🎯Target Batch - Canva Graphic Design Course_enc",
        link: "https://t.me/c/2270190947/20751/33452",
      },
      {
        name: "🎯Target Batch - Computer Fundamental_enc",
        link: "https://t.me/c/2270190947/20751/33419",
      },
      {
        name: "🎯Target Batch - Computer Hardware_enc",
        link: "https://t.me/c/2270190947/20751/33390",
      },
    
    ],
  },
  {
    category: "Code Help Courses",
    courses: [
      {
        name: "Data Structures & Algorithms BootCamp Supreme 2.0",
        link: "https://t.me/c/2270190947/9422/9423",
      },
    ],
  },
  {
    category: "Code with Mosh Courses",
    courses: [
      {
        name: "Django Series",
        link: "https://t.me/c/2270190947/36827/40019",
      },
      {
        name: "🥀 Mastering React",
        link: "https://t.me/c/2270190947/36827/40037",
      },
      {
        name: "Complete Python Mastery",
        link: "https://t.me/c/2270190947/36827/40049",
      },
      {
        name: "Node JS",
        link: "https://t.me/c/2270190947/36827/40065",
      },
      {
        name: "The Ultimate Redux Course",
        link: "https://t.me/c/2270190947/36827/40082",
      },
      {
        name: "DS Algo Series",
        link: "https://t.me/c/2270190947/36827/40094",
      },
      {
        name: "Git Series",
        link: "https://t.me/c/2270190947/36827/40126",
      },
      {
        name: "Javascript for Beginners",
        link: "https://t.me/c/2270190947/36827/40136",
      },
      {
        name: "ASP.NET",
        link: "https://t.me/c/2270190947/36827/40154",
      },
      {
        name: "ASP.NET CORE",
        link: "https://t.me/c/2270190947/36827/40156",
      },
      {
        name: "C#",
        link: "https://t.me/c/2270190947/36827/40161",
      },
      {
        name: "CODE REFACTORING",
        link: "https://t.me/c/2270190947/36827/40166",
      },
      {
        name: "DATA STRUCTURES AND ALGORITHMS",
        link: "https://t.me/c/2270190947/36827/40168",
      },
      {
        name: "DESIGN PATTERNS",
        link: "https://t.me/c/2270190947/36827/40179",
      },
      {
        name: "ENTITY FRAMEWORK",
        link: "https://t.me/c/2270190947/36827/40187",
      },
      {
        name: "JAVA",
        link: "https://t.me/c/2270190947/36827/40191",
      },
      {
        name: "REACT NATIVE",
        link: "https://t.me/c/2270190947/36827/40204",
      },
      {
        name: "SQL",
        link: "https://t.me/c/2270190947/36827/40206",
      },
      {
        name: "XAMARIN FORMS",
        link: "https://t.me/c/2270190947/36827/40215",
      },
      {
        name: "ANGULAR",
        link: "https://t.me/c/2270190947/36827/40217",
      },
   
    ],
  },
  {
    category: "AL Suffa Online Academy Courses",
    courses: [
      {
        name: "Adobe Illustrator Course By Al Suffa Online",
        link: "https://t.me/c/2270190947/17928/17929",
      },
      {
        name: "Adobe Premiere Pro Course By Al Suffa Online",
        link: "https://t.me/c/2270190947/17928/17930",
      },
      {
        name: "Adobe Photo Shop Course By Al Suffa Online",
        link: "https://t.me/c/2270190947/17928/17931",
      },
      {
        name: "Basic To Advance Computer Course By Al Suffa Online Academy ",
        link: "https://t.me/c/2270190947/17928/24507",
      },
      {
        name: "Digital Calligraphy Complete Course By Al Suffa Online Academy",
        link: "https://t.me/c/2270190947/17928/24507",
      },
      {
        name: "Mobile Graphics Designing Complete Course By Al Suffa Online Academy",
        link: "https://t.me/c/2270190947/17928/24507",
      },
      {
        name: "Mobile Video Editing Complete Course By Al Suffa Online Academy",
        link: "https://t.me/c/2270190947/17928/24507",
      },
      {
        name: "Ms Office Experts Complete Course By Al Suffa Online Academy",
        link: "https://t.me/c/2270190947/17928/24507",
      },
      {
        name: "Spoken English Complete Course By Al Suffa Online Academy",
        link: "https://t.me/c/2270190947/17928/24507",
      },
      {
        name: "Basic To Advance Fiverr Complete Course By Al Suffa Online Academy",
        link: "https://t.me/c/2270190947/17928/24507",
      },
      {
        name: "YouTube Professional Complete Course By Al Suffa Online Academy",
        link: "https://t.me/c/2270190947/17928/24507",
      },
    ],
  },
  {
    category: "INeuron Courses",
    courses: [
    {
        name: "Data Science Master Course",
        link: "https://t.me/c/2270190947/2752",
    },
    {
        name: "Big Data BOOTCAMP",
        link: "https://t.me/c/2270190947/3036",
    },
    {
        name: "Full Stack Web Development",
        link: "https://t.me/c/2270190947/3170",
    },
    {
        name: "Full Stack JavaScrip",
        link: "https://t.me/c/2270190947/3226",
    },
    {
        name: "Full Stack Java Developer",
        link: "https://t.me/c/2270190947/23813",
    },
    {
        name: "Blockchain",
        link: "https://t.me/c/2270190947/3305",
    },
    
    ],
  },
  {
    category: "Krish Naik Courses",
    courses: [
      {
        name: "Data Analysis Masterclass",
        link: "https://t.me/c/2270190947/13248/13249",
      },
      {
        name: "SQL Masterclass",
        link: "https://t.me/c/2270190947/13248/13551",
      },
      {
        name: "Power BI",
        link: "https://t.me/c/2270190947/13248/14092",
      },
      {
        name: "Feature Engineering",
        link: "https://t.me/c/2270190947/13248/13847",
      },
      {
        name: "Microsoft Server",
        link: "https://t.me/c/2270190947/13248/13886",
      },
      {
        name: "Excel Course",
        link: "https://t.me/c/2270190947/13248/14211",
      },
      {
        name: "Tableau Course",
        link: "https://t.me/c/2270190947/13248/14464",
      },
      {
        name: "Udemy – Complete Generative AI Course With Langchain and Huggingface",
        link: "https://t.me/c/2270190947/13248/14464",
      },
      {
        name: "Udemy – Complete Machine Learning,NLP Bootcamp MLOPS & Deployment",
        link: "https://t.me/c/2270190947/13248/14556",
      },
      {
        name: " Udemy – Building Gen AI App 12+ Hands-on Projects with Gemini Pro",
        link: "https://t.me/c/2270190947/13248/14557",
      },
      {
        name: "Udemy – Complete Data Analyst Bootcamp From Basics To Advanced",
        link: "https://t.me/c/2270190947/13248/14558",
      },
      {
        name: "Udemy – Complete Python With DSA Bootcamp + LEETCODE Exercises",
        link: "https://t.me/c/2270190947/13248/14559",
      },
      {
        name: "Udemy – Complete MLOps Bootcamp With 10+ End To End ML Projects",
        link: "https://t.me/c/2270190947/13248/14560",
      },
      {
        name: "Udemy – Complete Data Analyst Bootcamp From Basics To Advanced",
        link: "https://t.me/c/2270190947/13248/14562",
      },
      {
        name: "Udemy – Big Data Engineering Bootcamp with GCP, and Azure Cloud",
        link: "https://t.me/c/2270190947/13248/14563",
      },
      {
        name: "🔅 Udemy – Complete MLOps Bootcamp With 10+ End To End ML Projects ",
        link: "https://t.me/c/2270190947/3588/3627",
      },
    ],
  },
  {
    category: "Dhruv Rathee Courses",
    courses: [
      {
        name: "DHRUV RATHEE - TIME MANAGEMENT Premium COURSE ",
        link: "https://t.me/c/2270190947/2694/21113",
      },
      {
        name: "Dhruv Rathee Master Chatgpt Course",
        link: "https://t.me/c/2270190947/2694/20484",
      },
      {
        name: "Dhruv Rathee YouTube Blueprint 2024 🔥⚡️",
        link: "https://t.me/c/2270190947/2694/18345",
      },
      {
        name: "The AI Masterclass_Live Workshop 2025 🔥⚡️",
        link: "https://t.me/c/2270190947/2694/36308",
      },
    ],
  },
  
  {
    category: "Ranveer Allahbadia Courses",
    courses: [
      {
        name: "Ranveer Allahbadia Instagram 101 Mentorship 2024",
        link: "https://t.me/c/2270190947/28949/28951",
      },
    
    ],
  },
  {
    category: "Kashif Majeed Courses",
    courses: [
      {
        name: "Blogging Master Class",
        link: "https://t.me/c/2270190947/3740/3741"
      },
      {
        name:"Facebook Earning Masterclass",
        link: "https://t.me/c/2270190947/3740/3741"
      },
      {
        name:"Fiver Freelancing",
        link: "https://t.me/c/2270190947/3740/3741"
      },
      {
        name:"Grow Youtube Channel",
        link: "https://t.me/c/2270190947/3740/3741"
      },
      {
        name:"YouTube Long Videos Mastery",
        link: "https://t.me/c/2270190947/3740/3741"
      },
      {
        name:"YouTube Seo Masterclass",
        link: "https://t.me/c/2270190947/3740/3741"
      },
      {
        name:"YouTube Shorts Mastery",
        link: "https://t.me/c/2270190947/3740/3741"
      }
    
    ],
  },
  {
    category: "Abdul Bari Courses",
    courses: [
      {
        name: "Data Structures & Algorithms using C and C++ Master Course",
        link: "https://t.me/c/2270190947/9459/10850",
      },
      {
        name: "Learn, Analyse and Implement Data Structure using C and C++. Learn Recursion and Sorting",
        link: "https://t.me/c/2270190947/9459/10850",
      },
      {
        name: "Java SE -Complete Master Course",
        link: "https://t.me/c/2270190947/9459/10850",
      },
      {
        name: "C++ Programming - Beginner to Advance",
        link: "https://t.me/c/2270190947/9459/10850",
      },
      {
        name: "Learn C++ 11 Concepts,Develop an Application,Solve Online Coding Challenges",
        link: "https://t.me/c/2270190947/9459/10850",
      }
    ],
  },
  {
    category: "Ankur Warikoo Courses",
    courses: [
      {
        name: "Make Writing a Career by Ankur Warikoo ✍️",
        link: "https://t.me/c/2270190947/35061/35598",
      },
      {
        name: "LACB",
        link: "https://t.me/c/2270190947/35061/35529",
      },
      {
        name: "📌 How to linkedin",
        link: "https://t.me/c/2270190947/35061/35448",
      },
      {
        name: "How to Instagram",
        link: "https://t.me/c/2270190947/35061/35306",
      },
      {
        name: "📌 TAKE CHARGE OF YOUR MONEY 💰 ANKUR WARIKO",
        link: "https://t.me/c/2270190947/35061/35262",
      },
      {
        name: "🚀  Personality Development",
        link: "https://t.me/c/2270190947/35061/35234",
      },
      {
        name: "📌 ANKUR WARIKO : HOW TO YOUTUBE",
        link: "https://t.me/c/2270190947/35061/35166",
      },
      {
        name: "📌 ANKUR WARIKO:- TAKE CHARGE OF YOUR TIME 💸",
        link: "https://t.me/c/2270190947/35061/35154",
      },
      {
        name: "📌 How to Speak Effectively by Ankur Warikoo",
        link: "https://t.me/c/2270190947/35061/35140",
      },
      {
        name: "📌 the complete Guide to starting up",
        link: "https://t.me/c/2270190947/35061/35126",
      },
      {
        name: "Time Management For Students - Ankur Warikoo",
        link: "https://t.me/c/2270190947/35061/35095",
      },
      {
        name: "📌 THE ULTIMATE GUIDE TO EFFECTIVE COMMUNICATION ❤️‍🔥",
        link: "https://t.me/c/2270190947/35061/35063",
      },
    ],
  },
  {
    category: "Prakhar Gupta Courses",
    courses: [
      {
        name: "Happiness Manifesto By Prakhar Gupta ✅",
        link: "https://t.me/c/2270190947/35878/36509",
      },
      {
        name: "📌 1. master the art of conversation",
        link: "https://t.me/c/2270190947/35878/35881",
      },
   
    ],
  },
  {
    category: "Shahid Mentorship Program",
    courses: [
      {
        name: "Amazon FBA Private Label Course",
        link: "https://t.me/c/2270190947/3735/3737",
      },
      {
        name:"AMAZON FBM Course",
        link: "https://t.me/c/2270190947/3735/3737"
        },
        {
        name: "Amazon Wholesale Course",
        link: "https://t.me/c/2270190947/3735/3737"
        },
        {
        name: "Airbnb AR Course",
        link: "https://t.me/c/2270190947/3735/3737"
        },
        {
        name: "DropShipping Course",
        link: "https://t.me/c/2270190947/3735/3737"
        },
        {
        name: "How to sell on Facebook MarketPlace Course",
        link: "https://t.me/c/2270190947/3735/3737"
        },
        {
        name: "Affiliate Marketing Course",
        link: "https://t.me/c/2270190947/3735/3737"
        },
        {
        name: "Stock & Crypto Market Investing Course",
        link: "https://t.me/c/2270190947/3735/3737"
        },{
        name: "NFTs",
        link: "https://t.me/c/2270190947/3735/3737"
        },
        
    ],
  },
  {
    category: "Shahid Anwar Courses",
    courses: [
      {
        name: "Amazon Complete Mastry Course by Shahid Anwar",
        link: "https://t.me/c/2270190947/3736/3739",
      },
      {
        name:"SHAHID ANWAR Shopify Drop Shipping",
        link: "https://t.me/c/2270190947/3736/3739",
        },
        {
        name: "Shahid Anwar Wholesale FBA:",
        link: "https://t.me/c/2270190947/3736/3739",
        },
        {
        name: "Amazon FBA Global Selling Course:",
        link: "https://t.me/c/2270190947/3736/3739",
        },
        {
        name: "Shahid Anwar $300 Courses Links",
        link: "https://t.me/c/2270190947/3736/3739",
        },
        {
        name: "facebook marketing course",
        link: "https://t.me/c/2270190947/3736/3739",
        },
        {
        name: "Shahid Anwar Crypto Trading Course",
        link: "https://t.me/c/2270190947/3736/3832"
        },
       
        
    ],
  },
  {
    category: "Andrew Tate",
    courses: [
      {
        name: "Andrew Tate – Network Brilliance",
        link: "https://t.me/c/2270190947/2740/20842",
      },
      {
        name: "Andrew Tate – War Room Trading Academy Millionaire",
        link: "https://t.me/c/2270190947/2740/2742",
      },
      {
        name: "Andrew Tate The Real World",
        link: "https://t.me/c/2270190947/2740/2743",
      },
      {
        name: "Iron Mind By Andrew Tate",
        link: "https://t.me/c/2270190947/2740/20846",
      },
      {
        name: "Andrew Tate - AI Campus🤯🔥🔥🔥",
        link: "https://t.me/c/2270190947/2740/2745",
      },
      {
        name: "Andrew Tate course and PDF",
        link: "https://t.me/c/2270190947/2740/2748",
      },
      {
        name: "ANDREW TATE 8 HR BUSINESS",
        link: "https://t.me/c/2270190947/2740/20840",
      },
      {
        name: "ANDREW TATE'S BODY LANGUAGE",
        link: "https://t.me/c/2270190947/2740/20844",
      },
      {
        name: "PHD PROGRAM BY ANDREW TATE",
        link: "https://t.me/c/2270190947/2740/20853",
      },
      {
        name: "GOD MODE BY TRISTAN TATE",
        link: "https://t.me/c/2270190947/2740/20860",
      },
      {
        name: "HOW TO BE A G BY ANDREW TATE",
        link: "https://t.me/c/2270190947/2740/20866",
      },
      {
        name: "MASTER CHESS BY ANDREW TATE",
        link: "https://t.me/c/2270190947/2740/20889",
      },
      {
        name: "FITNESS BY ANDREW TATE",
        link: "https://t.me/c/2270190947/2740/20896",
      },
      {
        name: "ONLY FANS FORTUNE BY ANDREW TATE",
        link: "https://t.me/c/2270190947/2740/20899",
      },
      {
        name: "HUSTLERS UNIVERSITY 1.0 & 4.0",
        link: "https://t.me/c/2270190947/2740/20902",
      },
      {
        name: "CRYPTO",
        link: "https://t.me/c/2270190947/2740/20940",
      },
      {
        name: "COPYWRITING",
        link: "https://t.me/c/2270190947/2740/20943",
      },
      {
        name: "FREELANCING",
        link: "https://t.me/c/2270190947/2740/20948",
      },
      {
        name: "THE REAL WORLD - AMAZON FBA",
        link: "https://t.me/c/2270190947/2740/20933",
      },
      {
        name: "ECOMMERCE",
        link: "https://t.me/c/2270190947/2740/20935",
      },
    ],  
  },
  {
    category: "Technical Sagar",
    courses: [
      {
        name: "Hackstars - Cybersecurity Course",
        link: "https://t.me/c/2270190947/17605/33385",
      },
      {
        name: "Money Making Course",
        link: "https://t.me/c/2270190947/17605/17618",
      },
      {
        name: "Quick Hack - Beginners Ethical Hacking Course",
        link: "https://t.me/c/2270190947/17605/176345",
      },
      {
        name: "All Deleted Videos",
        link: "https://t.me/c/2270190947/17605/17606",
      },
      {
        name: "Tech Master",
        link: "https://t.me/c/2270190947/17605/33600",
      },
    ],
  },
  {
    category: "Zakir Khan",
    courses: [
      {
        name: " Frontrow | Learn Storytelling - Zakir Khan",
        link: "https://t.me/c/2270190947/20658/21128",
      },
    ],
  },
  {
    category: "Rachna Ranade",
    courses: [
      {
        name: "𝐂𝐀 𝐑𝐚𝐜𝐡𝐧𝐚 𝐑𝐚𝐧𝐚𝐝𝐞 - 𝐏𝐫𝐨 𝐈𝐧𝐯𝐞𝐬𝐭𝐨𝐫 𝐒𝐞𝐫𝐢𝐞𝐬 𝐒𝐩𝐞𝐜𝐢𝐚𝐥",
        link: "https://t.me/c/2270190947/21393/33202",
      },
      {
        name: "Magic of Mutual Funds",
        link: "https://t.me/c/2270190947/21393/33197",
      },
      {
        name: "Basics of Stock Market",
        link: "https://t.me/c/2270190947/21393/33050",
      },
      {
        name: "🔻 CA Rachna Ranade Course  Technical analysis 🔻",
        link: "https://t.me/c/2270190947/21393/21443",
      },
      {
        name: "🔻 CA Rachna Ranade Fundamental 2.0 Course 🔻",
        link: "https://t.me/c/2270190947/21393/21395",
      },
    ],
  },
  {
    category: "Angela Yu Courses",
    courses: [
      {
        name: "100 Days of Code: The Complete Python Pro Bootcamp for 2024",
        link: "https://t.me/c/2270190947/7767/7768",
      },
      {
        name: "The Complete 2024 Web Development Bootcamp",
        link: "https://t.me/c/2270190947/7767/7882",
      },
      {
        name: "Angela Yu - iOS & Swift: The Complete iOS App Development ",
        link: "https://t.me/c/2270190947/7767/8582",
      },
    ],
  },
  {
    category: "Iman Gadzhi Courses",
    courses: [
      {
        name: "🔻 IMAN GADZHI – SIX FIGURE SMMA 🔻",
        link: "https://t.me/c/2270190947/20947/21138",
      },
      {
        name: "🔻 IMAN GADZHI – COPY PASTE AGENCY 🔻",
        link: "https://t.me/c/2270190947/20947/21236",
      },
      {
        name: "🔻 IMAN GADZHI – AGENCY NAVIGATOR 🔻",
        link: "https://t.me/c/2270190947/20947/21264",
      },
      {
        name: "🔻 IMAN GADZHI – KAIZEN CURE 🔻",
        link: "https://t.me/c/2270190947/20947/21294",
      },
      {
        name: "🔻 IMAN GADZHI – PEN TO PROFIT 🔻",
        link: "https://t.me/c/2270190947/20947/21298",
      },
      {
        name: "🔻 IMAN GADZHI – WATCH INVESTOR 🔻",
        link: "https://t.me/c/2270190947/20947/21348",
      },
    ],
  },
  {
    category: "TechWorld with Nana",
    courses: [
      {
        name: "TechWorld with Nana - All Courses",
        link: "https://t.me/c/2270190947/23434/23438",
      },
    ],
  },
  {
    category: "Love Babbar",
    courses: [
      {
        name: "Web Development",
        link: "https://t.me/c/2270190947/5912/5913",
      },
      {
        name: "[DBMS] CodeHelp - by Babbar",
        link: "https://t.me/c/2270190947/5912/6103",
      },
      {
        name: "MERN",
        link: "https://t.me/c/2270190947/5912/9427",
      },
    ],
  },
  {
    category: "Waqar Zaka Courses",
    courses: [
      {
        name: "Waqar Zaka School 2023 (Latest Updated)",
        link: "https://t.me/c/2270190947/3833/3834",
      },
      {
        name: "Crypto Private School By Waqar Zaka",
        link: "https://t.me/c/2270190947/3833/3835",
      },
    ],
  },
  {
    category: "Ali Abdal Courses",
    courses: [
      {
        name: "📌 How to study for exams Ali abdal",
        link: "https://t.me/c/2270190947/35017/35019",
      },
      {
        name: "Ali Abdaal Editing🎬 Assets Pack",
        link: "https://t.me/c/2270190947/35017/35964",
      },
    ],
  },
  {
    category: "Technical Sagar",
    courses: [
      {
        name: "Technical Sagar Deleted Video From YouTube",
        link: "https://t.me/c/2270190947/17605/17606",
      },
      {
        name: "Money Making",
        link: "https://t.me/c/2270190947/17605/17618",
      },
      {
        name: "Masters In Ethical Hacking",
        link: "https://t.me/c/2270190947/17605/17634",
      },
      {
        name: "Courses Collection",
        link: "https://t.me/c/2270190947/17605/17679",
      },
    ],
  },
  {
    category: "📢💡 Digital Marketing and Money Making Courses",
    courses: [
      {
        name: "Sebastian Esqueda and Sebastian Ghiorghiu: Discover Tik Tok Dropshipping Intermediate",
        link: "https://t.me/c/2270190947/520/521",
      },
      {
        name: "Niklas Pedde - Instagram University 4.0 ",
        link: "https://t.me/c/2270190947/520/522",
      },
      {
        name: "NATHANIEL DREW & JOHNNY HARRIS — VISUAL STORYTELLING ⚡️🎥",
        link: "https://t.me/c/2270190947/520/523",
      },
      {
        name: "ANKUR WARIKOO — PUBLIC SPEAKING COURSE ⚡️🗣",
        link: "https://t.me/c/2270190947/520/530",
      },
      {
        name: "BRIAN KURTZ — BREAKTHROUGH ADVERTISING MASTERY ⚡️📈",
        link: "https://t.me/c/2270190947/520/532",
      },
      {
        name: "NOMADIC KINGDOM — SOCIAL MEDIA MASTERING PROGRAM ⚡️🔥",
        link: "https://t.me/c/2270190947/520/535",
      },
      {
        name: "THOMAS OWEN — ADPROFITS ACADEMY ⚡️💵",
        link: "https://t.me/c/2270190947/520/538",
      },
      {
        name: "GREG AND NATE — COMEDY ADS MASTERCLASS ⚡️📣",
        link: "https://t.me/c/2270190947/520/541",
      },
      {
        name: "💕 Digital Marketing Premium Course All  ",
        link: "https://t.me/c/2270190947/520/542",
      },
      {
        name: "CARLY CAMBELL — PINTEREST STRATEGIES 2025 ⚡️🔥",
        link: "https://t.me/c/2270190947/520/543",
      },
      {
        name: "DANNY POSTMA — SEO BLUEPRINT ⚡️📈",
        link: "https://t.me/c/2270190947/520/544",
      },
      {
        name: "MICHAEL NEILL — UNF*CKING YOUR RELATIONSHIP WITH MONEY ⚡️💵",
        link: "https://t.me/c/2270190947/520/545",
      },
      {
        name: "MARIA WENDT — ADS ACCELERATOR OUR RETARGETING STRATEGIES ⚡️📈",
        link: "https://t.me/c/2270190947/520/546",
      },
      {
        name: "MAHA COPY SHOP — 6-FIGURE STORY LAUNCH MASTERCLASS ⚡️🔥",
        link: "https://t.me/c/2270190947/520/549",
      },
      {
        name: "MITCH BAYLIS — MAKE.COM ADVANCED BUSINESS AUTOMATION COURSE ⚡️🆒",
        link: "https://t.me/c/2270190947/520/550",
      },
      {
        name: "KJ RAINEY — ALL COURSES ⚡️🔥",
        link: "https://t.me/c/2270190947/520/551",
      },
      {
        name: "CHELSEA BLACKWELL — THE ONE ⚡️⭐️",
        link: "https://t.me/c/2270190947/520/552",
      },
      {
        name: "BEN HEATH — FACEBOOK ADS MASTERY ⚡️🔥",
        link: "https://t.me/c/2270190947/520/553",
      },
      {
        name: "BRENDON BURCHARD — INFLUENCE PRO ⚡️🆒",
        link: "https://t.me/c/2270190947/520/554",
      },
      {
        name: "BEN HEATH — FACEBOOK ADS MASTERY ⚡️🔥",
        link: "https://t.me/c/2270190947/520/558",
      },
      {
        name: "ZUBAIR TRABZADA — AI WORKSHOP ⚡️🤑",
        link: "https://t.me/c/2270190947/520/561",
      },
      {
        name: "FOUNDR — AI ACCELERATOR PROGRAM ⚡️🤯",
        link: "https://t.me/c/2270190947/520/562",
      },
      {
        name: "HOWARD BERG — LEARNING GENIUS STUDENT BUNDLE ⚡️💡",
        link: "https://t.me/c/2270190947/520/563",
      },
      {
        name: "NEHEMIAH DAVIS — EVENT SPACE SECRETS ⚡️🖥",
        link: "https://t.me/c/2270190947/520/564",
      },
      {
        name: "Depesh Mandalia Courses Bundle 2025",
        link: "https://t.me/c/2270190947/520/568",
      },
      {
        name: "NEHEMIAH DAVIS — EVENT SPACE SECRETS ⚡️🖥",
        link: "https://t.me/c/2270190947/520/564",
      },
      {
        name: "NEHEMIAH DAVIS — EVENT SPACE SECRETS ⚡️🖥",
        link: "https://t.me/c/2270190947/520/564",
      },
      {
        name: "Ecommerce Masterclass By Ali Swati 🥵",
        link: "https://t.me/c/2270190947/520/32957",
      },
    ],
  },
  {
    category: "🎬 Video Editing Courses",
    courses: [
      {
        name: "Tharun Speaks - Video Editing",
        link: "https://t.me/c/2270190947/5830/21131",
      },
      {
        name: "Mahatmaji Technical Video editing course",
        link: "https://t.me/c/2270190947/29663",
      },
      {
        name: "Billi4you - Tausif Khalid All course",
        link: "https://t.me/c/2270190947/24557/24559",
      },
      {
        name: " Gigl zero to hero video editing course ",
        link: "https://t.me/c/2270190947/31214",
      },
      {
        name: "From Zero to Hero: Mastering After Effects, SFX, and AI Techniques",
        link: "https://t.me/c/2270190947/31203",
      },
      {
        name: "Rajeev Mehta documentry style video editing course ",
        link: "https://t.me/c/2270190947/30805",
      },
      {
        name: "Mk Tv video editing course ",
        link: "https://t.me/c/2270190947/30805",
      },
      {
        name: " Master High-Converting Designs",
        link: "https://t.me/c/2270190947/30745",
      },
      {
        name: "Professor of How 3D Animation Course ✨",
        link: "https://t.me/c/2270190947/30495",
      },
      {
        name: "T-Shirt Design Mastery Using A. I and Adobe Illustrator",
        link: "https://t.me/c/2270190947/20751/32694",
      },
      {
        name: "Capcut for Desktop: The Ultimate Video Editing Course for Reels and TikTok Creators",
        link: "https://t.me/c/2270190947/20751/32711",
      },
      {
        name: "Basic to Advance Adobe Animate Course By Shani Malik🚀",
        link: "https://t.me/c/2270190947/577/32505",
      },
      {
        name: "Complete Photography Course",
        link: "https://t.me/c/2270190947/9433/17723",
      },
      {
        name: "Daniel Kordan Photo Editing Masterclass🔥 5 Hours in 26 Videos, signature post processing explained",
        link: "https://t.me/c/2270190947/9433/17917",
      },
      {
        name: "Pro Editing Workflow in DaVinci Resolve",
        link: "https://t.me/c/2270190947/9433/17932",
      },
      {
        name: "Mr Beast Editor Hayden Hillier Video Editing Course",
        link: "https://t.me/c/2270190947/9433/17946",
      },
      {
        name: "Getting Started with After Effects - Nikhil Pawar",
        link: "https://t.me/c/2270190947/9433/20555",
      },
      {
        name: "Rachit Singh",
        link: "https://t.me/c/2270190947/9433/24510",
      },
      {
        name: "mana visual course Dhruv rathee editor ",
        link: "https://t.me/c/2270190947/9433/25510",
      },
      {
        name: "Mobile Video Editing Course",
        link: "https://t.me/c/2270190947/9433/29449",
      },
      {
        name: "The_Beginner's_Guide_to_Adobe_Premiere_Pro_Edit_Like_a_Pro",
        link: "https://t.me/c/2270190947/3588/3733",
      },
      {
        name: "Adobe Illustrator for Everyone Design Like a Pro",
        link: "https://t.me/c/2270190947/3588/3730",
      },
      {
        name: "How to Earn from Photography Absolute Beginners Guide ",
        link: "https://t.me/c/2270190947/3588/3725",
      },
      {
        name: "Canva Design Mastery From Beginner to Advanced ",
        link: "https://t.me/c/2270190947/3588/3723",
      },
      {
        name: "Adobe Photoshop CC MasterClass From Beginner to Advanced",
        link: "https://t.me/c/2270190947/3588/3722",
      },
      {
        name: "Adobe Illustrator CC - Beginners to Advanced Training ",
        link: "https://t.me/c/2270190947/3588/3720",
      },
      {
        name: "Essential Photoshop Course for Beginner To Advanced",
        link: "https://t.me/c/2270190947/3588/3715",
      },
      {
        name: "Canva for Social Media Zero to Hero Graphic Design",
        link: "https://t.me/c/2270190947/3588/3717",
      },
    ],
  },
  {
    category: "💡 Freelancing Courses",
    courses: [
      {
        name: "SHREYA PATTAR – FREELANCING FREEDOM",
        link: "https://t.me/c/2270190947/20771/20834",
      },
      {
        name: "Freelance Freedom- Mohak Mangal",
        link: "https://t.me/c/2270190947/20771/20810",
      },
      {
        name: "Ultimate Freelancing Course",
        link: "https://t.me/c/2270190947/20771/20804",
      },
      {
        name: "Freelance Mastery with Smartphone 3D Logo",
        link: "https://t.me/c/2270190947/20771/20801",
      },
      {
        name: "Fiver Freelancing with Smartphone",
        link: "https://t.me/c/2270190947/20771/20795",
      },
      {
        name: "Freelance Dashboard",
        link: "https://t.me/c/2270190947/20771/20792",
      },
      {
        name: "Freelance 101 Academy🔻",
        link: "https://t.me/c/2270190947/20771/20775",
      },
      {
        name: "Easy Online - Freelanceing🔻",
        link: "https://t.me/c/2270190947/20771/20778",
      },
    ],
  },
  {
    category: "🗣️ English Speaking Courses",
    courses: [
      {
        name: "Aleena Raees",
        link: "https://t.me/c/2270190947/9461/20575",
      },
      {
        name: "Mahatmaji Technical Video editing course ",
        link: "https://t.me/c/2270190947/29663",
      },
      {
        name: "English Course Basic A1",
        link: "https://t.me/c/2270190947/9441/33288",
      },
    ],
  },
  {
    category: "⚙️ Hacking Courses",
    courses: [
      {
        name: "ZD Research Academy",
        link: "https://t.me/c/2270190947/4163/4251",
      },
      {
        name: "Collection of Best Ethical Hacking Courses",
        link: "https://t.me/c/2270190947/4163/26655",
      },
      {
        name: "Wscube Ethical Hacking Courses",
        link: "https://t.me/c/2270190947/5905/5907",
      },
      {
        name: "🔰 Complete Ethical Hacking Bootcamp 2021: Zero to Mastery",
        link: "https://t.me/c/2270190947/3588/4132",
      },
      {
        name: "🔆Nmap For Penetration Testing: Beginner To Advanced",
        link: "https://t.me/c/2270190947/4163/36563",
      },
      {
        name: "Full Ethical Hacking Course Network Penetration Testing",
        link: "https://t.me/c/2270190947/4163/36506",
      },
    ],
  },
  {
    category: "🎨🖌️ Graphic Designing Courses",
    courses: [
      {
        name: "Best Course of Graphic Designing",
        link: "https://t.me/c/2270190947/22271/22273",
      },
      {
        name: "GFXMentor",
        link: "https://t.me/c/2270190947/22271/24386",
      },
      {
        name: "Design Like A Pro - Vaibhav Designing Course ✅",
        link: "https://t.me/c/2270190947/22271/36236",
      },
      {
        name: "Adobe Photoshop Mega Mastery Course Novice to Pro 2024 + AI",
        link: "https://t.me/c/2270190947/22271/35690",
      },
      {
        name: "⭐️Maya 3D Animation ✅",
        link: "https://t.me/c/2270190947/22271/33336",
      },
      {
        name: "⭐️Best Course of Graphic Designing ✅",
        link: "https://t.me/c/2270190947/22271/22273",
      },
    ],
  },
  {
    category: "🗣️🌍 Learn Language Courses",
    courses: [
      {
        name: "Learn German",
        link: "https://t.me/c/2270190947/19880/19882",
      },
      
    ],
  },
  {
    category: "📈📊 Trading Courses",
    courses: [
      {
        name: "AirKam Trader | Golden Bullet",
        link: "https://t.me/c/2270190947/209/210",
      },
      {
        name: "Fenix Pinheiro Trading (Funded Trader) -  Advanced Trading Mentorship Course",
        link: "https://t.me/c/2270190947/209/211",
      },
      {
        name: "Global Financial Markets : Fundamental & Technical Analysis",
        link: "https://t.me/c/2270190947/209/216",
      },
      {
        name: "Meshach Zarwie - ICT Mentorship 2023",
        link: "https://t.me/c/2270190947/209/218",
      },
      {
        name: "Trading Hub 4.0",
        link: "https://t.me/c/2270190947/209/226",
      },
      {
        name: "Global Trade Finance Mastery Tools Risks Strategies",
        link: "https://t.me/c/2270190947/209/228",
      },
      {
        name: "YARIMI UNIVERSITY — FOREX ⚡️💹",
        link: "https://t.me/c/2270190947/209/230",
      },
      {
        name: "Jrod (Reim's student) - The Trading Shelter (LIT Concepts",
        link: "https://t.me/c/2270190947/209/233",
      },
      {
        name: "The Soup Room T.S.R Premium",
        link: "https://t.me/c/2270190947/209/236",
      },
      {
        name: "King Of Forex – The 1 Trading Strategy",
        link: "https://t.me/c/2270190947/209/247",
      },
      {
        name: "The Trading Academy Course (TTA)",
        link: "https://t.me/c/2270190947/209/251",
      },
      {
        name: "Willy Jay - Supply and Demand",
        link: "https://t.me/c/2270190947/209/249",
      },
      {
        name: "Fortunee Bulls Academy",
        link: "https://t.me/c/2270190947/209/312",
      },
      {
        name: "Impactfxreal Mentorship",
        link: "https://t.me/c/2270190947/209/317",
      },
      {
        name: "Kingofvix75 Mentorship",
        link: "https://t.me/c/2270190947/209/324",
      },
        {
          name: "US30 Bootcamp – PLFCrypto ",
          link: "https://t.me/c/2270190947/209/337",
        },
      {
        name: "Saint Brian Course",
        link: "https://t.me/c/2270190947/209/343",
      },
      {
        name: "Evolution Markets Higher Timeframe Trading Course 2023",
        link: "https://t.me/c/2270190947/209/339",
      },
      {
        name: "TradingView Pine Script 102 – The Complete Strategy Guide",
        link: "https://t.me/c/2270190947/209/353",
      },
      {
        name: "DanDowdTrading",
        link: "https://t.me/c/2270190947/209/368",
      },
      {
        name: "LEARN TO TRADE & INVEST – (HINDI) | RARE LEAK! ",
        link: "https://t.me/c/2270190947/209/26289",
      },
      {
        name: "📈 Unlock Your Financial Future with Our Exclusive Trading Course! 📉",
        link: "https://t.me/c/2270190947/209/26286",
      },
      {
        name: "LEARN TO TRADE & INVEST – (HINDI) | RARE LEAK! ",
        link: "https://t.me/c/2270190947/209/26289",
      },
    ],
  },
  {
    category: "🎨🖌️ Dropshipping & Shopify Courses",
    courses: [
      {
        name: "Yashika Garg 6 Figure Drop Shipping Mastery",
        link: "https://t.me/c/2270190947/158/25509",
      },
      {
        name: "Indian Dropshipping Product Research Mastery",
        link: "https://t.me/c/2270190947/20598/20600",
      },
      {
        name: "Dropshipping  Course By Chirag Mehta",
        link: "https://t.me/c/2270190947/20598/20641",
      },
      {
        name: "Max Conversion Shopify Course By David Kollar",
        link: "https://t.me/c/2270190947/9433/17947",
      },
      {
        name: "Ahmad waqas Drop shipping course",
        link: "https://t.me/c/2270190947/9438/9439",
      },
      {
        name: "Talha Reviews Drop shipping course",
        link: "https://t.me/c/2270190947/9438/9439",
      },
    ],
  },
  {
    category: "🖥️ Programming Courses",
    courses: [
      {
        name: "🔅 Crack SQL Interview : 200+ Questions with Concept Building",
        link: "https://t.me/c/2270190947/3588/3596",
      },
      {
        name: "🔅 Udemy – 101 Practice SQL Questions: Basic to Advanced",
        link: "https://t.me/c/2270190947/3588/3597",
      },
      {
        name: "🔆JavaScript Algorithms and Data Structures Masterclass",
        link: "https://t.me/c/2270190947/416/36614",
      },
      {
        name: "🔅 Udemy – Data Engineering on AWS – The complete training ",
        link: "https://t.me/c/2270190947/3588/3598",
      },
      {
        name: "👣 Flutter Full Stack Tutorial – Spotify Clone ",
        link: "https://t.me/c/2270190947/416/36789",
      },
      {
        name: "🔰 Complete React Native Bootcamp (with Hooks)",
        link: "https://t.me/c/2270190947/416/36757",
      },
      {
        name: "🔰 The Complete React Native + Hooks Course",
        link: "https://t.me/c/2270190947/416/36741",
      },
      {
        name: "🔅 Build a Music Player app with React Native, Expo, Typescript and Zustand",
        link: "https://t.me/c/2270190947/416/36720",
      },
      {
        name: "🔅 Full Stack Flutter, Firebase and Riverpod – Build a YouTube Clone",
        link: "https://t.me/c/2270190947/416/36719",
      },
      {
        name: "🔆 (https://t.me/Udemy_Learning) Mastering REST APIs with FastAPI",
        link: "https://t.me/c/2270190947/416/36644",
      },
      {
        name: "🔅 Udemy – SQL Essentials – Thinking in SQL form Beginners to Pro ",
        link: "https://t.me/c/2270190947/3588/3599",
      },
      {
        name: "🔅 Udemy – Apache Spark 3 – Beyond Basics and Cracking Job Interviews ",
        link: "https://t.me/c/2270190947/3588/3600",
      },
      {
        name: "🔅 Udemy – Apache Spark 3 – Spark Programming in Scala for Beginners ",
        link: "https://t.me/c/2270190947/3588/3601",
      },
      {
        name: "Complete System design Course LLD + HLD",
        link: "https://t.me/c/2270190947/416/36065",
      },
      {
        name: "🔅 Udemy – Databricks – Master Azure Databricks for Data Engineers ",
        link: "https://t.me/c/2270190947/3588/3602",
      },
      {
        name: "🔅 Udemy – Apache Kafka – Real-time Stream Processing Master Class",
        link: "https://t.me/c/2270190947/3588/3603",
      },
      {
        name: "🔅 Udemy – Apache Spark and Databricks – Stream Processing in Lakehouse ",
        link: "https://t.me/c/2270190947/3588/3604",
      },
      {
        name: "🔅 Udemy – PySpark – Apache Spark Programming in Python for beginners",
        link: "https://t.me/c/2270190947/3588/3605",
      },
      {
        name: "🔅 Udemy – Big Data Hadoop and Spark with Scala",
        link: "https://t.me/c/2270190947/3588/3606",
      },
      {
        name: "🔅 Udemy – Master Big Data – Apache Spark/Hadoop/Sqoop/Hive/Flume/Mongo",
        link: "https://t.me/c/2270190947/3588/3607",
      },
      {
        name: "🔅 Udemy – Algorithmic Trading with Apache Flink | Hands-on guide ",
        link: "https://t.me/c/2270190947/3588/3608",
      },
      {
        name: "🔅 Udemy – Azure Data Engineer Technologies for Beginners [Bundle] ",
        link: "https://t.me/c/2270190947/3588/3609",
      },
      {
        name: "🔅 Udemy – Algorithmic Trading with Apache Flink | Hands-on guide ",
        link: "https://t.me/c/2270190947/3588/3608",
      },
      {
        name: "🔅 Udemy – Data Warehouse – The Ultimate Guide ",
        link: "https://t.me/c/2270190947/3588/3612",
      },
      {
        name: "🔅 Udemy – Designing Data Warehouse From Scratch: End to End Guide",
        link: "https://t.me/c/2270190947/3588/3613",
      },
      {
        name: "🔅 Udemy – Mastering Data Structures & Algorithms using C and C++ by Abdul Bari ",
        link: "https://t.me/c/2270190947/3588/3614",
      },
      {
        name: "🔅 Udemy – Learn C++ Programming -Beginner to Advance- Deep Dive in C++ by Abdul Bari ",
        link: "https://t.me/c/2270190947/3588/3615",
      },
      {
        name: "🔅 Udemy – Learn JAVA Programming – Beginner to Master by Abdul Bari ",
        link: "https://t.me/c/2270190947/3588/3616",
      },
      {
        name: "🔅 Udemy – Learn Python Programming – Beginner to Master  by Abdul Bari ",
        link: "https://t.me/c/2270190947/3588/3617",
      },
      {
        name: "🔅 Udemy – DevOps Beginners to Advanced with Projects",
        link: "https://t.me/c/2270190947/3588/3618",
      },
      {
        name: "🔅 DevOps Projects | Real Time DevOps & GitOps Projects",
        link: "https://t.me/c/2270190947/3588/3619",
      },
      {
        name: "🔅 Udemy – A deep dive in deep learning ocean with Pytorch & TensorFlow",
        link: "https://t.me/c/2270190947/3588/3620",
      },
      {
        name: "🔅 Udemy – The Ultimate Web Scraping With Python Bootcamp 2024",
        link: "https://t.me/c/2270190947/3588/3625",
      },
      {
        name: "🔅 Udemy – Complete Python Web Scraping : Real Projects & Modern Tools",
        link: "https://t.me/c/2270190947/3588/3626",
      },
      {
        name: "🔅 Udemy – The Ultimate Web Scraping With Python Bootcamp 2024",
        link: "https://t.me/c/2270190947/3588/3625",
      },
      {
        name: "🔅 Udemy – The Ultimate Web Scraping With Python Bootcamp 2024",
        link: "https://t.me/c/2270190947/3588/3625",
      },
      {
        name: "🔅 Udemy – Nextjs & Mern Stack Build Advance Job Portal 2025",
        link: "https://t.me/c/2270190947/3588/3633",
      },
      {
        name: "🔅 Udemy – Build an AI-Powered News Website with Next.js & React",
        link: "https://t.me/c/2270190947/3588/3634",
      },
      {
        name: "🔅 Udemy – Power BI – Business Intelligence for Beginners to Advance",
        link: "https://t.me/c/2270190947/3588/3635",
      },
      {
        name: "🔅 Udemy – Power Pivoting: Microsoft Power BI for Career Changers",
        link: "https://t.me/c/2270190947/3588/3636",
      },
      {
        name: "🔅 Power Bi - Master Power Bi with 40+ hours of Premium Content",
        link: "https://t.me/c/2270190947/3588/3637",
      },
      {
        name: "🔅 Udemy – Build this Modern UX/UI Designed Power BI Desktop Report",
        link: "https://t.me/c/2270190947/3588/3638",
      },
      {
        name: "🔅 Udemy – Microsoft Power BI Portfolio in a Day",
        link: "https://t.me/c/2270190947/3588/3639",
      },
      {
        name: "🔅 Udemy – Microsoft Power BI: The Art of Designing Incredible Tools",
        link: "https://t.me/c/2270190947/3588/3640",
      },
      {
        name: "🔅 Udemy – Complete DAX Bootcamp for Power BI from Beginner to Advanced",
        link: "https://t.me/c/2270190947/3588/3641",
      },
      {
        name: "🔅 Udemy – SQL for Data Analysis: Advanced SQL Querying Techniques",
        link: "https://t.me/c/2270190947/3588/3642",
      },
      {
        name: " Master the Coding Interview: Data Structures + Algorithms",
        link: "https://t.me/c/2270190947/3588/4154",
      },
      {
        name: " 🔰 Complete Python Developer in 2021: Zero To Mastery ",
        link: "https://t.me/c/2270190947/3588/4011",
      },
      {
        name: " Udemy Wordpress Course ",
        link: "https://t.me/c/2270190947/3588/3714",
      },
      
      {
        name: "Udemy- Microsoft Excel Zero To Advanced: Data Analysis & Dashboards",
        link: "https://t.me/c/2270190947/3588/3710",
      },
      {
        name: "Become a C++ Programming Expert",
        link: "https://t.me/c/2270190947/3588/3709",
      },
      
      {
        name: "❤️‍🔥𝐔𝐃𝐄𝐌𝐘 𝐏𝐑𝐄𝐌𝐈𝐔𝐌 𝐂𝐎𝐔𝐑𝐒𝐄𝐒  Kafi courses hannn",
        link: "https://t.me/c/2270190947/3588/3708",
      },
      
      {
        name: "30+ 🔥Udemy Courses🔥",
        link: "https://t.me/c/2270190947/3588/3707",
      },
      {
        name: "Complete 3D FPS Game in Unity C# For Beginners 2024",
        link: "https://t.me/c/2270190947/3588/3706",
      },
      {
        name: "🌟 Exploring The DarkWeb || ALL LINKS REVEAL 🌟",
        link: "https://t.me/c/2270190947/3588/3705",
      },
      {
        name: "DeepFakes Masterclass: Machine Learning The Easy Way",
        link: "https://t.me/c/2270190947/3588/3704",
      },
      
      {
        name: "Master Faceless TikTok Marketing with AI, ChatGPT & Canva!",
        link: "https://t.me/c/2270190947/3588/3703",
      },
      {
        name: "✅ TikTok AUTOMATION Course ✅",
        link: "https://t.me/c/2270190947/36061/36128",
      },
      
      {
        name: "AI Cold Calling Course 2024: Automate Phone Calls using AI",
        link: "https://t.me/c/2270190947/3588/3702",
      },
      {
        name: "🔅 Udemy – Python for Time Series Data Analysis",
        link: "https://t.me/c/2270190947/3588/3701",
      },
      {
        name: "🔅 Udemy – Time Series Analysis, Forecasting, and Machine Learning",
        link: "https://t.me/c/2270190947/3588/3700",
      },
      {
        name: "🔅 Udemy – Power BI for Professionals: Master Data Storytelling",
        link: "https://t.me/c/2270190947/3588/3643",
      },
      {
        name: "🔅 Udemy – Building Automated Machine Images with HashiCorp Packer",
        link: "https://t.me/c/2270190947/3588/3644",
      },
      {
        name: "🔅 Udemy – Microsoft Fabric – The Complete Guide ",
        link: "https://t.me/c/2270190947/3588/3645",
      },
      {
        name: "🔅 Udemy – Microsoft Fabric Data Engineering Mastery: A Complete Guide",
        link: "https://t.me/c/2270190947/3588/3646",
      },
      {
        name: "🔅 Udemy – Master Microsoft Fabric: A Complete End-to-End Project- CICD",
        link: "https://t.me/c/2270190947/3588/3647",
      },
      {
        name: "🔅 Udemy – Machine Learning & Data Science: The Complete Visual Guide",
        link: "https://t.me/c/2270190947/3588/3648",
      },
      {
        name: "🔅 Udemy – Python Data Science: Data Prep & EDA with Python",
        link: "https://t.me/c/2270190947/3588/3649",
      },
      {
        name: "🔅 Udemy – Python Data Science: Unsupervised Machine Learning",
        link: "https://t.me/c/2270190947/3588/3650",
      },
      {
        name: "🔅 Udemy – Python Data Science: Classification Modeling",
        link: "https://t.me/c/2270190947/3588/3651",
      },
      {
        name: "🔅 Udemy – Python Data Science: Regression & Forecasting",
        link: "https://t.me/c/2270190947/3588/3652",
      },
      {
        name: "🔅 Udemy – Build Responsive Real-World Websites with HTML and CSS",
        link: "https://t.me/c/2270190947/3588/3653",
      },
      {
        name: "🔅 Udemy – Advanced CSS and Sass: Flexbox, Grid, Animations and More!",
        link: "https://t.me/c/2270190947/3588/3654",
      },
      {
        name: "🔅 Udemy – The Complete JavaScript Course 2025: From Zero to Expert!",
        link: "https://t.me/c/2270190947/3588/3655",
      },
      {
        name: "🔅 Udemy – The Ultimate React Course 2024: React, Next.js, Redux & More",
        link: "https://t.me/c/2270190947/3588/3656",
      },
      {
        name: "🔅 Udemy – Node.js, Express, MongoDB & More: The Complete Bootcamp",
        link: "https://t.me/c/2270190947/3588/3657",
      },
      {
        name: "🔅 Udemy – Comprehensive SQL Course:Hands-on Project & Coding Exercises",
        link: "https://t.me/c/2270190947/3588/3658",
      },
      {
        name: "🔅 Udemy – Azure Data Factory For Data Engineers – Project on Covid19",
        link: "https://t.me/c/2270190947/3588/3659",
      },
      {
        name: "🔅 Udemy – Azure Synapse Analytics For Data Engineers -Hands On Project",
        link: "https://t.me/c/2270190947/3588/3660",
      },
      {
        name: "🔅 Udemy – Azure Databricks & Spark For Data Engineers (PySpark / SQL)",
        link: "https://t.me/c/2270190947/3588/3661",
      },
      {
        name: "🔅 Practice Exams: Databricks Certified Data Engineer Associate",
        link: "https://t.me/c/2270190947/3588/3674",
      },
      {
        name: "🔅 Udemy – Python 3: Fundamentals",
        link: "https://t.me/c/2270190947/3588/3675",
      },
      {
        name: "🔅 Udemy – Python 3: Deep Dive (Part 1 – Functional)",
        link: "https://t.me/c/2270190947/3588/3676",
      },
      {
        name: "🔅 Udemy – Python 3: Deep Dive (Part 2 – Iterators, Generators)",
        link: "https://t.me/c/2270190947/3588/3677",
      },
      {
        name: "🔅 Udemy – Python 3: Deep Dive (Part 3 – Dictionaries, Sets, JSON)",
        link: "https://t.me/c/2270190947/3588/3678",
      },
      {
        name: " 🔅 Udemy – Python 3: Deep Dive (Part 4 – OOP)",
        link: "https://t.me/c/2270190947/3588/3679",
      },
      
      {
        name: "🔅 Udemy – Pydantic V2: Essentials ",
        link: "https://t.me/c/2270190947/3588/3680",
      },
      
      {
        name: " 🔅 Udemy – DSA In Python + Top 100 Leetcode Problems for MAANG ",
        link: "https://t.me/c/2270190947/3588/3681",
      },
      
      {
        name: " 🔅 Udemy – 50 Days of DSA PYTHON Data Structures & Algorithms LEETCODE ",
        link: "https://t.me/c/2270190947/3588/3682",
      },
      
      {
        name: "🔅 Udemy – Microsoft Fabric Deep Dive: Fabric Guide ",
        link: "https://t.me/c/2270190947/3588/3683",
      },
      
      {
        name: " 🔅 Udemy – 15 Days of SQL: The Complete SQL Masterclass 2024",
        link: "https://t.me/c/2270190947/3588/3685",
      },
      
      {
        name: " 🔅 Udemy – Snowflake – The Complete Masterclass",
        link: "https://t.me/c/2270190947/3588/3685",
      },
      {
        name: " 🔅 Udemy – Complete A.I. & Machine Learning, Data Science Bootcamp",
        link: "https://t.me/c/2270190947/3588/3686",
      },
      {
        name: " 🔅 Udemy – The Complete Android 14 & Kotlin Development Masterclass",
        link: "https://t.me/c/2270190947/3588/3687",
      },
      {
        name: " 🔅 Udemy – The Modern Flexbox, Grid, Sass & Animations Developer Course ",
        link: "https://t.me/c/2270190947/3588/3688",
      },
      {
        name: " 🔅 Udemy – Ultimate AWS Data Engineering Bootcamp: 15 Real-World Labss",
        link: "https://t.me/c/2270190947/3588/3689",
      },
      {
        name: " 🔅 Udemy – Data Engineering Essentials using SQL, Python, and PySpark ",
        link: "https://t.me/c/2270190947/3588/3690",
      },
      {
        name: "🔅 Udemy – Master Airflow: Beginner to Advance with Project",
        link: "https://t.me/c/2270190947/3588/3691",
      },
      {
        name: " 🔅 Udemy – 15 days of Power BI – Complete Microsoft Power BI Bootcamp ",
        link: "https://t.me/c/2270190947/3588/3692",
      },
      
      {
        name: "🔅 Udemy – Complete AWS Certified Data Engineer Associate – DEA-C01 ",
        link: "https://t.me/c/2270190947/3588/3693",
      },
      
      {
        name: " 🔅 Udemy – Microsoft Excel – Excel from Beginner to Advanced",
        link: "https://t.me/c/2270190947/3588/3694",
      },
      
      {
        name: " 🔅 Udemy – Data Lake Mastery: The Key to Big Data & Data Engineering",
        link: "https://t.me/c/2270190947/3588/3695",
      },
      
      {
        name: " 🔅 Udemy – Signal processing problems, solved in MATLAB and in Python",
        link: "https://t.me/c/2270190947/3588/3696",
      },
      
      {
        name: "🔅 Udemy – Python Data Structures & Algorithms + LEETCODE Exercises",
        link: "https://t.me/c/2270190947/3588/3697",
      },
      
      {
        name: " 🔅 Udemy – System Design for Big Data Pipelines",
        link: "https://t.me/c/2270190947/3588/3698",
      },
      
      {
        name: " 🔅 Udemy – Mastering the System Design Interview  ",
        link: "https://t.me/c/2270190947/3588/3699",
      },
      
      {
        name: "Flutter_Masterclass_Dart,_APIs,_Firebase_&_More_2024",
        link: "https://t.me/c/2270190947/416/417",
      },
      {
        name: "Hack_Proof_Banking_Defend_Against_Credit_Card_Threats",
        link: "https://t.me/c/2270190947/416/422",
      },
      {
        name: "PHP Laravel Build Real Estate Management System",
        link: "https://t.me/c/2270190947/416/425",
      },
      {
        name: "Full Stack Developer Learning Path",
        link: "https://t.me/c/2270190947/416/428",
      },
      {
        name: "Full Stack Developer Learning Path",
        link: "https://t.me/c/2270190947/416/428",
      },
      {
        name: "Java Programming Course",
        link: "https://t.me/c/2270190947/416/429",
      },
      {
        name: "Git & GitHub for Beginners From Start to Star",
        link: "https://t.me/c/2270190947/416/431",
      },
      {
        name: "EatTheBlocks — COURSES ⚡️🤩",
        link: "https://t.me/c/2270190947/416/432",
      },
      {
        name: "JavaScript Fundamentals for Absolute Beginners",
        link: "https://t.me/c/2270190947/416/434",
      },
      {
        name: "Mastering Jenkins Building Continuous Integration Pipelines",
        link: "https://t.me/c/2270190947/416/435",
      },
      {
        name: "Mobile Cybersecurity Awareness",
        link: "https://t.me/c/2270190947/416/438",
      },
      {
        name: "Python CourseLearn Python By building Games in Python",
        link: "https://t.me/c/2270190947/416/439",
      },
      {
        name: "Snowflake Snowpark API for Python Master Class with Project",
        link: "https://t.me/c/2270190947/416/442",
      },
      {
        name: "Advanced JAVA course",
        link: "https://t.me/c/2270190947/416/443",
      },
      {
        name: "Web Development Python ",
        link: "https://t.me/c/2270190947/416/444",
      },
      {
        name: "Java + Spring Boot, Rest Web Services, MVC, Microser",
        link: "https://t.me/c/2270190947/416/445",
      },
      {
        name: "NodeJS Masterclass (Express, MongoDB, OpenAI) - 2024",
        link: "https://t.me/c/2270190947/416/452",
      },
      {
        name: "Python Data Structures & Algorithms Ace Coding Interview",
        link: "https://t.me/c/2270190947/416/454",
      },
      {
        name: "Web Development Bootcamp with HTML CSS PHP MySQL",
        link: "https://t.me/c/2270190947/416/456",
      },
      {
        name: "Advanced C++11141720 Programming-34 hrs course in 12",
        link: "https://t.me/c/2270190947/416/459",
      },
      {
        name: "Django Masterclass Get Started With Django Web Developme",
        link: "https://t.me/c/2270190947/416/464",
      },
      {
        name: "Mastering ChatGPT, Midjourney, and Powerful AI Tools",
        link: "https://t.me/c/2270190947/416/467",
      },
      {
        name: "Complete Railway Reservation System Using STREAMLIT & SQ",
        link: "https://t.me/c/2270190947/416/470",
      },
      {
        name: "iOS Development Kickstart Craft Your First App With SwiftUI ",
        link: "https://t.me/c/2270190947/416/472",
      },
      {
        name: "Next_Gen_Web_Development_JavaScript_&_AI_Essentials",
        link: "https://t.me/c/2270190947/416/474",
      },
      {
        name: "Maîtriser_Github_Actions_et_les_pipelines_DevOps_CICD",
        link: "https://t.me/c/2270190947/416/475",
      },
      {
        name: "Cryptocurrency_Investing_with_Python_Earn_Passive_Income",
        link: "https://t.me/c/2270190947/416/478",
      },
      {
        name: "2024 C Programming Bootcamp - The Complete C Language ",
        link: "https://t.me/c/2270190947/416/480",
      },
      {
        name: "Python CourseLearn Python By building Games in Python",
        link: "https://t.me/c/2270190947/416/484",
      },
      {
        name: "ReactJs - The Complete ReactJs Course For Beginners",
        link: "https://t.me/c/2270190947/416/485",
      },
      {
        name: "C# Mastering Course For Beginners",
        link: "https://t.me/c/2270190947/416/487",
      },
      {
        name: "Certified Kubernetes Security Specialist Masterclass",
        link: "https://t.me/c/2270190947/416/489",
      },
      {
        name: "Coding for everybody Full stack development course",
        link: "https://t.me/c/2270190947/416/492",
      },
      {
        name: "Learn to Code HTML & CSS for Responsive Real-World ",
        link: "https://t.me/c/2270190947/416/495",
      },
      {
        name: "Complete Railway Reservation System Using STREAMLIT & SQ",
        link: "https://t.me/c/2270190947/416/498",
      },
      {
        name: "Android Very Basic App Development Course with Java",
        link: "https://t.me/c/2270190947/416/501",
      },
      {
        name: "User Experience Design - Learn UI UX App Design",
        link: "https://t.me/c/2270190947/416/504",
      },
      {
        name: "Software Testing Mastery Bootcamp Course 2024",
        link: "https://t.me/c/2270190947/416/506",
      },
      {
        name: "Flipkart Review Sentiment Analysis & Spam Comments Detec",
        link: "https://t.me/c/2270190947/416/509",
      },
      {
        name: "Udemy - Learn Python Programming - Beginner to Master",
        link: "https://t.me/c/2270190947/416/511",
      },
      {
        name: "The Complete Rust Programming Course",
        link: "https://t.me/c/2270190947/416/517",
      },
      {
        name: "React - Learn React with Hooks by creating a Roguelike",
        link: "https://t.me/c/2270190947/416/519",
      },
      {
        name: "🟡 JavaScript - The Complete Guide 2024 (Beginner + Advanced)",
        link: "https://t.me/c/2270190947/416/2143",
      },
      {
        name: "🖥  ChatGPT, Midjourney, DALL-E 3 & APIs - The Complete Guide",
        link: "https://t.me/c/2270190947/416/5809",
      },
      {
        name: "The Complete Guide to Freelancing zero to mastery",
        link: "https://t.me/c/2270190947/416/20699",
      },
      {
        name: "Neetcode.io - System Design for Beginners",
        link: "https://t.me/c/2270190947/416/20701",
      },
     
     
    ],
  },
  
  {
    category: "🤖🧠⚙️ Artificial Intelligence & Machine Learning & Data Science 📊🚀",
    courses: [
      {
        name: "AI Prompt Engineering - Beginner Course",
        link: "https://t.me/c/2270190947/25073",
      },
      {
        name: "AI Course by IDM Pakistani",
        link: "https://t.me/c/2270190947/9444/9445",
      },
      {
        name: "Tech Burner AI Course",
        link: "https://t.me/c/2270190947/5837/5838",
      },
      {
        name: "Coursera – Data Science: Statistics and Machine Learning Specialization",
        link: "https://t.me/c/2270190947/3663/3664",
      },
      {
        name: "🔆 (https://t.me/Udemy_Learning) ChatGPT, Midjourney, DALL-E 3 & APIs - The Complete Guide",
        link: "https://t.me/c/2270190947/8662/36595",
      },
      {
        name: "🔆 (https://t.me/Udemy_Learning) Artificial Intelligence A-Z 2025: Build 7 AI + LLM & ChatGPT",
        link: "https://t.me/c/2270190947/8662/36575",
      },
      {
        name: "Coursera – IBM Introduction to Machine Learning Specialization",
        link: "https://t.me/c/2270190947/3663/3665",
      },
      {
        name: "Coursera – Machine Learning Specialization (Andrew Ng) 2024-10 + Extras",
        link: "https://t.me/c/2270190947/3663/3666",
      },
      {
        name: "Coursera – Deep Learning Specialization ",
        link: "https://t.me/c/2270190947/3663/3667",
      },
      {
        name: "Udemy – Data Science & Machine Learning(Theory+Projects)A-Z 90 HOURS ",
        link: "https://t.me/c/2270190947/3588/3589",
      },
      {
        name: "AppliedAICourse – Applied Machine Learning Online Course",
        link: "https://t.me/c/2270190947/3588/3590",
      },
      {
        name: "🔅 Mathematics-Basics to Advanced for Data Science And GenAI ",
        link: "https://t.me/c/2270190947/3588/3591",
      },
      {
        name: "🔅 Udemy – Data Science Real World Projects in Python ",
        link: "https://t.me/c/2270190947/3588/3592",
      },
      {
        name: "🔅 Udemy – Data Science Bundle: 180 Hands-On Projects – Course 1 of 3",
        link: "https://t.me/c/2270190947/3588/3593",
      },
      {
        name: "🔅 Udemy – Data Science Bundle: 180 Hands-On Projects – Course 2 of 3",
        link: "https://t.me/c/2270190947/3588/3594",
      },
      {
        name: "🔅 Udemy – Data Science Bundle: 180 Hands-On Projects – Course 3 of 3",
        link: "https://t.me/c/2270190947/3588/3595",
      },
      {
        name: "🔅 Udemy – Build 75 Powerful Data Science & Machine Learning Projects ",
        link: "https://t.me/c/2270190947/3588/3610",
      },
      {
        name: "🔅 Udemy – 100 Days Data Science Bootcamp: Build 100 Real Life Projects",
        link: "https://t.me/c/2270190947/3588/3611",
      },
      {
        name: "🔅 Udemy – TensorFlow for Deep Learning Bootcamp",
        link: "https://t.me/c/2270190947/3588/3621",
      },
      {
        name: "🔅 Udemy – PyTorch for Deep Learning Bootcamp",
        link: "https://t.me/c/2270190947/3588/3622",
      },
      {
        name: "🔅 Udemy – Deep Learning Masterclass with TensorFlow 2 Over 20 Projects",
        link: "https://t.me/c/2270190947/3588/3623",
      },
      {
        name: "🔅 Udemy – Web Scraping in Python Selenium, Scrapy + ChatGPT Prize 2024",
        link: "https://t.me/c/2270190947/3588/3624",
      },
      {
        name: "🔅 Udemy – LangGraph- Develop LLM powered agents with LangGraph",
        link: "https://t.me/c/2270190947/3588/3630",
      },
      {
        name: "🔅 Udemy – Cursor Course: FullStack development with Cursor AI Copilot",
        link: "https://t.me/c/2270190947/3588/3631",
      },
      {
        name: "🔅 Udemy – LangChain- Develop LLM powered applications with LangChain",
        link: "https://t.me/c/2270190947/3588/3632",
      },
      {
        name: "🔰 Complete Machine Learning and Data Science 2021 - Zero to Mastery",
        link: "https://t.me/c/2270190947/3588/4048",
      },
      {
        name: "🔰 Complete Machine Learning and Data Science 2021",
        link: "https://t.me/c/2270190947/8662/8663",
      },
      {
        name: "🔰 TensorFlow Developer Certificate in 2023: Zero to Mastery",
        link: "https://t.me/c/2270190947/8662/8697",
      },
      {
        name: "🔰 Modern Computer Vision™ PyTorch, Tensorflow2 Keras & OpenCV4",
        link: "https://t.me/c/2270190947/8662/8752 ",
      },
      {
        name: "🔅 Pair Programming with AI",
        link: "https://t.me/c/2270190947/8662/8841",
      },
      {
        name: "🔅 Applied Machine Learning: Ensemble Learning",
        link: "https://t.me/c/2270190947/8662/8844",
      },
      {
        name: "🔅 Introduction to MLSecOps",
        link: "https://t.me/c/2270190947/8662/8849",
      },
      {
        name: "🔅 Artificial Intelligence Foundations: Neural Networks",
        link: "https://t.me/c/2270190947/8662/8852",
      },
      {
        name: "🔅 Artificial Intelligence Foundations: Thinking Machines",
        link: "https://t.me/c/2270190947/8662/8854",
      },
      {
        name: "🔰 NLP - Natural Language Processing with Python",
        link: "https://t.me/c/2270190947/8662/8858",
      },
      {
        name: "🔅 Artificial Intelligence for Students",
        link: "https://t.me/c/2270190947/8662/8879",
      },
      {
        name: "🔅 Understanding the Impact of Deepfake Videos",
        link: "https://t.me/c/2270190947/8662/8881",
      },
      {
        name: "🔅 Python for Data Science and Machine Learning Essential Training Part 1",
        link: "https://t.me/c/2270190947/8662/8883",
      },
      {
        name: "🔅 Python for Data Science and Machine Learning Essential Training Part 2",
        link: "https://t.me/c/2270190947/8662/8885",
      },
      {
        name: "🔅 Giving Computers Vision",
        link: "https://t.me/c/2270190947/8662/8887",
      },
      {
        name: "🔰 Artificial Intelligence & ChatGPT for Cyber Security 2024",
        link: "https://t.me/c/2270190947/8662/8908",
      },
      {
        name: "💸 Programming with AI ",
        link: "https://t.me/c/2270190947/8662/8928",
      },
      {
        name: "🔅 Machine Learning with Python: Foundations",
        link: "https://t.me/c/2270190947/8662/8946",
      },
      {
        name: "🔅 Hands-On AI: RAG using LlamaIndex",
        link: "https://t.me/c/2270190947/8662/8968",
      },
      {
        name: "🔅 Deep Learning: Model Optimization and Tuning",
        link: "https://t.me/c/2270190947/8662/8977",
      },
      {
        name: "🔅 Introduction to Large Language Models",
        link: "https://t.me/c/2270190947/8662/8984",
      },
      {
        name: "🔅 Machine Learning and AI Foundations: Advanced Decision Trees with KNIME",
        link: "https://t.me/c/2270190947/8662/9006",
      },
      {
        name: "🔅 Computer Vision on the Raspberry Pi 4",
        link: "https://t.me/c/2270190947/8662/9019",
      },
  
      {
        name: "🔰 AI Agents: Building Teams of LLM Agents that Work For You",
        link: "https://t.me/c/2270190947/8662/9043",
      },
      {
        name: "🔅 What Is Generative AI?",
        link: "https://t.me/c/2270190947/8662/9112",
      },
      {
        name: "🔅 Generative AI for Sales and Services Professionals",
        link: "https://t.me/c/2270190947/8662/9116",
      },
      {
        name: "🔅 Excel and ChatGPT: Data Analysis Power Tips",
        link: "https://t.me/c/2270190947/8662/9119",
      },
      {
        name: "🔅 Building a Video Transcriber with Node.js and OpenAI API",
        link: "https://t.me/c/2270190947/8662/9123",
      },
      {
        name: "🔅 Building a Video Transcriber with Node.js and Google AI Speech-To-Text API",
        link: "https://t.me/c/2270190947/8662/9126",
      },
      {
        name: "🔅 Top 10 Skills for Machine Learning Cloud Architects",
        link: "https://t.me/c/2270190947/8662/9129",
      },
      {
        name: "🔅 HTML, CSS, and Generative AI: Speed Up Your Process",
        link: "https://t.me/c/2270190947/8662/9131",
      },
      {
        name: "🔅 Generative AI for Product Managers",
        link: "https://t.me/c/2270190947/8662/9133",
      },
      {
        name: "🔅 Supervised Learning Essential Training",
        link: "https://t.me/c/2270190947/8662/9135",
      },
      {
        name: "🔅 Deep Learning Foundations: Natural Language Processing with TensorFlow",
        link: "https://t.me/c/2270190947/8662/9138",
      },
      {
        name: "🔅 Applied AI: Building NLP Apps with Hugging Face Transformers",
        link: "https://t.me/c/2270190947/8662/9141",
      },
      {
        name: "🔅 Advanced NLP with Python for Machine Learning",
        link: "https://t.me/c/2270190947/8662/9144",
      },
      {
        name: "🔅 TensorFlow: Working with NLP",
        link: "https://t.me/c/2270190947/8662/9147",
      },
      {
        name: "☄️What is an Artificial Neural Networks?",
        link: "https://t.me/c/2270190947/8662/9149",
      },
      {
        name: "🔅 Applied AI: Getting Started with Hugging Face Transformers",
        link: "https://t.me/c/2270190947/8662/9160",
      },
      {
        name: "🔅 Integrating Generative AI into JavaScript Web Projects",
        link: "https://t.me/c/2270190947/8662/9174",
      },
      {
        name: "🔰 Artificial Intelligence A-Z 2024: Build 7 AI + LLM & ChatGPT",
        link: "https://t.me/c/2270190947/8662/9177",
      },
      {
        name: "🔅 Machine Learning with Scikit-Learn",
        link: "https://t.me/c/2270190947/8662/9178",
      },
      {
        name: "🔅 Hands-On Data Annotation: Applied Machine Learning",
        link: "https://t.me/c/2270190947/8662/9181",
      },
      {
        name: "🔅 Machine Learning and AI Foundations: Producing Explainable AI (XAI) and Interpretable Machine Learning Solutions",
        link: "https://t.me/c/2270190947/8662/9185",
      },
      {
        name: "🔅 AI Pair Programming with GitHub Copilot X",
        link: "https://t.me/c/2270190947/8662/9188",
      },
      {
        name: "🔅 Machine Learning and AI Foundations: Causal Inference and Modeling",
        link: "https://t.me/c/2270190947/8662/9190",
      },
      {
        name: "🔅 Building a Video Transcriber with Node.js and Google AI Speech-To-Text API",
        link: "https://t.me/c/2270190947/8662/9194",
      },
      {
        name: "🔅 Introduction to AI-Native Vector Databases",
        link: "https://t.me/c/2270190947/8662/9197",
      },
      {
        name: "🔅 Machine Learning and AI Foundations: Advanced Decision Trees with KNIME",
        link: "https://t.me/c/2270190947/8662/9199",
      },
      {
        name: "🧠 Face Recognition with Machine Learning + Deploy Flask  App",
        link: "https://t.me/c/2270190947/8662/9204",
      },
      {
        name: "🔅 OpenCV for Python Developers",
        link: "https://t.me/c/2270190947/8662/9217",
      },
      {
        name: "🔅 Microsoft Designer: Create Stunning Designs with the Power of AI",
        link: "https://t.me/c/2270190947/8662/9218",
      },
      {
        name: "💰  Can AI really automate our jobs?",
        link: "https://t.me/c/2270190947/8662/9232",
      },
      {
        name: "🔅 Deep Learning and Generative AI: Data Prep, Analysis, and Visualization with Python",
        link: "https://t.me/c/2270190947/8662/9242",
      },
      {
        name: "🔅 Machine Learning and AI Foundations: Classification Modeling",
        link: "https://t.me/c/2270190947/8662/9248",
      },
      {
        name: "🔅 How To Start A Business Using Only AI",
        link: "https://t.me/c/2270190947/8662/9254",
      },
      {
        name: "🔰 Artificial Intelligence A-Z 2025: Build 7 AI + LLM & ChatGPT",
        link: "https://t.me/c/2270190947/8662/9255",
      },
      {
        name: "https://t.me/c/2270190947/8662/9255",
        link: "https://t.me/c/2270190947/8662/9275",
      },
      {
        name: "🔅 Amplify Your Personal Brand with Generative AI",
        link: "https://t.me/c/2270190947/8662/9279",
      },
      {
        name: "🔻 Midjourney Pro: Become AI Arts Expert 🔻",
        link: "https://t.me/c/2270190947/8662/21352",
      },
      {
        name: "🔻 AI Monetization Mastery ELITE  🔻",
        link: "https://t.me/c/2270190947/8662/21355",
      },  
     
      
    ],
  },
  {
    category: "💻🌐🎨 Web and Mobile Development Courses 🛠️🚀",
    courses: [
      {
        name: "Namaste React Akshay Saini Course",
        link: "https://t.me/c/2270190947/5903/10852",
      },
      {
        name: "Anuj Bhaiya MERN Stack",
        link: "https://t.me/c/2270190947/5903/5904",
      },
      {
        name: "💎Back-End Domination: Create Efficient Back-End💎 by Sheryians",
        link: "https://t.me/c/2270190947/10188/10189",
      },
      {
        name: "💎Front-End Domination: Create Anything with Code💎 by Sheryians",
        link: "https://t.me/c/2270190947/10188/13098",
      },
      {
        name: "React Course by SIMPLIFIED",
        link: "https://t.me/c/2270190947/9457/9458"
      },
      {
        name: "Harkirat Singh Cohort 1.0",
        link: "https://t.me/c/2270190947/7688/9350"
      },
      {
        name: "Harkirat Singh Cohort 2.0 - web dev",
        link: "https://t.me/c/2270190947/7688/7690"
      },
      {
        name: "Harkirat Singh Cohort 3.0 -  (web 3 + Web dev + devops + Blockchain)",
        link: "https://t.me/c/2270190947/7688/7689"
      },
      {
        name: "🔰 The Complete Web Developer in 2021: Zero to Mastery",
        link: "https://t.me/c/2270190947/3588/3970"
      },
      {
        name: "🧿 REST APIs with Flask and Python",
        link: "https://t.me/c/2270190947/3588/3949"
      },
      {
        name: "arpit bhayani system design masterclass",
        link: "https://t.me/c/2270190947/416/20721",
      },
      {
        name: "JavaScript Animation Course",
        link: "https://t.me/c/2270190947/416/20749",
      },
      {
        name: "Complete React Developer in 2023 (w/ Redux, Hooks, GraphQL)",
        link: "https://t.me/c/2270190947/416/23160",
      },
      {
        name: "React Native",
        link: "https://t.me/c/2270190947/416/23933",
      },
      {
        name: "Microservices with Node JS and React",
        link: "https://t.me/c/2270190947/416/23956",
      },
      {
        name: "MERN React Node Next.js Multi User SEO Blogging Platform",
        link: "https://t.me/c/2270190947/416/23985",
      },
      {
        name: "Fullstack Node.js and Express Bootcamp with Real Projects",
        link: "https://t.me/c/2270190947/416/24012",
      },
      {
        name: "Node.js Express.jz MangoDB With typescript",
        link: "https://t.me/c/2270190947/416/24029",
      },
      {
        name: "Crash Course Build a Full-Stack Web App in a Weekend!",
        link: "https://t.me/c/2270190947/416/24045",
      },
      {
        name: "MERN Stack Real Time Chat App With Express, React, MongoDB",
        link: "https://t.me/c/2270190947/416/24054",
      },
      {
        name: "Complete Back-End Development with NodeJS - LearnCodeOnline",
        link: "https://t.me/c/2270190947/416/24133",
      },
     
      
    ],
  },
  {
    category: "🎬 Video Book",
    courses: [
      {
        name: "THE 7 HABITS PF HIGHLY EFFECTIVE PEOPLE : POWERFULL LESSONS IN PERSONAL CHANGE",
        link: "https://t.me/c/2270190947/28770",
      },
      {
        name: "THE RICHEST MAN IN BABYLON",
        link: "https://t.me/c/2270190947/29467",
      },
     
    ],
  },
  {
    category: "🎬 YouTube Courses",
    courses: [
      {
        name: "Mastering YouTube Scriptwriting : From Idea to Viral Content",
        link: "https://t.me/c/2270190947/28938",
      },
      {
        name: "Yt Gyan USA course",
        link: "https://t.me/c/2270190947/29647",
      },
      {
        name: "Saqlain Khan - Youtube Playbook",
        link: "https://t.me/c/2270190947/25589/25596",
      },
      {
        name: "0 to 1 YouTube course algrow",
        link: "https://t.me/c/2270190947/31176",
      },
      {
        name: "Beat Youtube In 18 Days By Algrow",
        link: "https://t.me/c/2270190947/30193",
      },
      {
        name: "Voice Over Course",
        link: "https://t.me/c/2270190947/29906",
      },
      {
        name: "MK TV Youtube Masterclass",
        link: "https://t.me/c/2270190947/725/726",
      },
      {
        name: "📌 A2 sir YouTube Mastery Course",
        link: "https://t.me/c/2270190947/9447/33681",
      },
     
    ],
  },
  {
    category: "🔥 Mix Courses 📚🎨💻🔬🍳",
    courses: [
      {
        name: "Learn Gaming From 8Bit Thug & Mortal",
        link: "https://t.me/c/2270190947/21731",
      },
      {
        name: "All World High Premium Course's (Click kr kai dekh loo)",
        link: "https://t.me/c/2270190947/3588/3713",
      },
      {
        name: "Learn Linux From Scratch",
        link: "https://t.me/c/2270190947/25072",
      },
      {
        name: "Communication Masterclass by Tahsan",
        link: "https://t.me/c/2270190947/617/618",
      },
      {
        name: "Interview Preparation & Personality Development by Sumi Khandpur",
        link: "https://t.me/c/2270190947/28783",
      },
      {
        name: "Art Of Thumbnail By Deepak Dhaiya",
        link: "https://t.me/c/2270190947/21657",
      },
      {
        name: "Abhishek thumbnail editing course",
        link: "https://t.me/c/2270190947/31160",
      },
      {
        name: "Complete PMO Recovery & Advance Spiritual Journey",
        link: "https://t.me/c/2270190947/29465",
      },
      {
        name: "Time Management For Students - Ankur Warikoo",
        link: "https://t.me/c/2270190947/29601",
      },
      {
        name: "THE ULTIMATE GUIDE TO EFFECTIVE COMMUNICATION",
        link: "https://t.me/c/2270190947/29724",
      },
      {
        name: "The ultimate guide to quitting porn & masterbation ",
        link: "https://t.me/c/2270190947/31146",
      },
      {
        name: "Ghulam Ali Blogging Mastery (Batch 3) – Complete Course",
        link: "https://t.me/c/2270190947/31099",
      },
      {
        name: "Click kr kai dekh loo konsa course hai :)",
        link: "https://t.me/c/2270190947/31048",
      },
      {
        name: "COURSE TO BECOME A SUCCESSFUL BEAUTICIAN BY GUIDE CARRER 2024",
        link: "https://t.me/c/2270190947/30999",
      },
      {
        name: "Employee Hiring Course",
        link: "https://t.me/c/2270190947/30980",
      },
      {
        name: "Secret Of Money by CA Rahul Malodia",
        link: "https://t.me/c/2270190947/30979",
      },
      {
        name: "master the art of conversation",
        link: "https://t.me/c/2270190947/30829",
      },
      {
        name: "SNEH DESAI COURSE LAW OF ATTRACTION 🧲 😉",
        link: "https://t.me/c/2270190947/30822",
      },
      {
        name: " 30 Days Personality Development Challenge 🎯✨",
        link: "https://t.me/c/2270190947/30709",
      },
      {
        name: "GANDHI UNIVERSITY - SAURABH GANDHI",
        link: "https://t.me/c/2270190947/30680",
      },
      {
        name: "Fund Raising Course By Dr. Vivek Bindra",
        link: "https://t.me/c/2270190947/30390",
      },
      {
        name: "Mahatmaji Technical All courses bundle ⭐️",
        link: "https://t.me/c/2270190947/30235",
      },
      {
        name: "𝗘𝗻𝗴𝗹𝗶𝘀𝗵 𝗧𝘆𝗽𝗶𝗻𝗴 𝗖𝗼𝘂𝗿𝘀𝗲",
        link: "https://t.me/c/2270190947/30231",
      },
      {
        name: "📌 Monk mode challenge saurabh Gandhi",
        link: "https://t.me/c/2270190947/20751/32994",
      },
      {
        name: "📌 21 DAYS LAW OF ATTRACTION AND HAPPINESS COURSE",
        link: "https://t.me/c/2270190947/20751/32975",
      },
      {
        name: "BEST ONLINE ELECTRICIAN COURSE ",
        link: "https://t.me/c/2270190947/29756",
      },
      {
        name: "THE ULTIMATE GUIDE TO EFFECTIVE COMMUNICATION",
        link: "https://t.me/c/2270190947/29724",
      },
      {
        name: "📌 The Foundation Course on Indian stock market",
        link: "https://t.me/c/2270190947/33022",
      },
        {
          name: " Jordan Belfort - Straight Line Persuasion",
          link: "https://t.me/c/2270190947/21504/21624",
        },
      {
        name: "THE ALTER EGO EFFECT METHOD MASTERCLASS",
        link: "https://t.me/c/2270190947/21504/21620",
      },
      {
        name: "Joe Dispenza – Unlocked – Set Yourself Free ",
        link: "https://t.me/c/2270190947/21504/21616",
      },
      {
        name: "MindValley – Be a Modern Master – Deborah King",
        link: "https://t.me/c/2270190947/21504/21608",
      },
      {
        name: "Love Activation System – Real World Seduction – Josh Lubens",
        link: "https://t.me/c/2270190947/21504/21605",
      },
      {
        name: "The Modern Man – Dan Bacon – Mastery Methods And Mindsets",
        link: "https://t.me/c/2270190947/21504/21602",
      },
      {
        name: "The Modern Man – Dan Bacon – 21 Great Ways To Get A Girlfriend",
        link: "https://t.me/c/2270190947/21504/21599",
      },
      {
        name: "Tony Robbins – Become Unshakeable Challenge 2023",
        link: "https://t.me/c/2270190947/21504/21591",
      },
      {
        name: "Patrick Bet-David – All Access Bundle",
        link: "https://t.me/c/2270190947/21504/21568",
      },
      {
        name: "Basic to Advance SEO",
        link: "https://t.me/c/2270190947/804/805",
      },
      {
        name: "Become Unstoppable - A System to Unleash your Inner Beast ",
        link: "https://t.me/c/2270190947/21504/21556",
      },
      {
        name: " Zen ctivator – Zan Azahiro",
        link: "https://t.me/c/2270190947/21504/21550",
      },
      {
        name: "The Principles of Production - Ali Abdaal",
        link: "https://t.me/c/2270190947/21504/21534",
      },
      {
        name: " RSD Jeffy’s Resonator",
        link: "https://t.me/c/2270190947/21504/21526",
      },
      {
        name: "Dr K’s Guide to Mental Health",
        link: "https://t.me/c/2270190947/21504/21517",
      },
      {
        name: "Cultivate the Mind of the Warrior with David Goggins – Mindvalley",
        link: "https://t.me/c/2270190947/21504/21514",
      },
      {
        name: " Vinh Giang – STAGE Academy",
        link: "https://t.me/c/2270190947/21504/21506",
      },
      {
        name: "📌 THE PRODUCTIVE BUDDHA ♠️✅",
        link: "https://t.me/c/2270190947/20751/37137",
      },
      {
        name: "📌 MY SECRET TO EARN RS 50000 PER MONTH WITH WORDPRESS",
        link: "https://t.me/c/2270190947/20751/36846",
      },
      {
        name: "Dr. Ujjwal Patni - The Success Habit Program",
        link: "https://t.me/c/2270190947/20751/36520",
      },
      {
        name: "⚜️ Moggers Blue Print By PREM JOSHI ⚜️",
        link: "https://t.me/c/2270190947/20751/36310",
      },
      {
        name: "Risk management by idigitalpreneur ❤️‍🔥😎",
        link: "https://t.me/c/2270190947/20751/36134",
      },
      {
        name: "💥Frontrow - Raftaar Rap Course : Rap Your Hearts Out With Raftaar🔥",
        link: "https://t.me/c/2270190947/20751/35968",
      },
      {
        name: "💎Malala Teaches Creating Changes💎",
        link: "https://t.me/c/2270190947/20751/36281",
      },
      {
        name: "One Page Website With Canva 🙈",
        link: "https://t.me/c/2270190947/9465/32515",
      },
      {
        name: "Share market Course ",
        link: "https://t.me/c/2270190947/20751/32564",
      },
      {
        name: "LLD - Low Level System Design ",
        link: "https://t.me/c/2270190947/11571/11572",
      },
      {
        name: "HLD Batch 2 - High Level System Design",
        link: "https://t.me/c/2270190947/11571/11573",
      },
      {
        name: "CSE All Subject Courses",
        link: "https://t.me/c/2270190947/9424/9425",
      },
      {
        name: "Chess Lessons by GM Mesgen Amanov - Vol. 1-3 Bundle",
        link: "https://t.me/c/2270190947/20751/32607",
      },
      {
        name: "Crush the Caro-Kann Chess Opening: Tactics, Tricks and Traps by tryfon gavriel",
        link: "https://www.udemy.com/course/chess-openings-beating-the-caro-kann-with-tricks-and-traps/",
      },
      {
        name: "Legends of 1.e4 chess",
        link: "https://t.me/c/2270190947/20751/32620",
      },
      {
        name: "Attack Mode by Shwetabh Gangwar",
        link: "https://t.me/c/2270190947/20675/35993",
      },
      {
        name: "Nuclear mode 🌚 by Shwetabh Gangwar",
        link: "https://t.me/c/2270190947/20675/25815",
      },
      {
        name: "Foreign University Courses",
        link: "https://t.me/c/2270190947/9455/9456",
      },
      {
        name: "Made Easy : GATE CSE Complete Course With All Subjects ",
        link: "https://t.me/c/2270190947/25341/25344",
      },
      {
        name: "🔻 CA Rachna Ranade Course  Technical analysis 🔻",
        link: "https://t.me/c/2270190947/21393/21443",
      },
      {
        name: "🔻 CA Rachna Ranade Fundamental 2.0 Course 🔻",
        link: "https://t.me/c/2270190947/21393/21395",
      },
      {
        name: "Mastering ChatGPT, Midjourney, and Powerful AI Tools ",
        link: "https://t.me/c/2270190947/3588/3727",
      },
      {
        name: "📌 21 DAYS LAW OF ATTRACTION AND HAPPINESS COURSE",
        link: "https://t.me/c/2270190947/20751/32975",
      },
      {
        name: "📌 Monk mode challenge saurabh Gandhi",
        link: "https://t.me/c/2270190947/20751/32994",
      },
     
     
    ],
  },
];

export default CoursesProducts;